// Regras de tamanho do vídeo (módulo puro, sem Swal/DOM — testável).

export const VIDEO_MAX_SIZE = 20971520; // 20MB — vídeo comum
export const VIDEO_MAX_SIZE_PROVADOR = 31457280; // 30MB — Vídeo Provador

// Empresas isentas do limite de tamanho do vídeo.
const SLUGS_SEM_LIMITE = ["caramella"];

export const isVideoSizeExempt = (slug) =>
  SLUGS_SEM_LIMITE.includes(String(slug ?? "").trim().toLowerCase());

// Retorna { ok, msg } — msg só é preenchida quando ok === false.
export const checkVideoSize = (inp_files, provador, slug) => {
  if (isVideoSizeExempt(slug)) return { ok: true };

  const size = provador ? VIDEO_MAX_SIZE_PROVADOR : VIDEO_MAX_SIZE;
  const msg = provador
    ? "O tamanho máximo do vídeo é 30MB."
    : "O tamanho máximo do vídeo é 20MB.";

  const files = inp_files || [];
  for (let i = 0; i < files.length; i++) {
    if (files[i].type === "video/mp4" && files[i].size > size) {
      return { ok: false, msg };
    }
  }
  return { ok: true };
};
